
import { defineComponent, getCurrentInstance, ref } from '@vue/composition-api';
import DatePicker from 'vue2-datepicker';

import { enumToArray } from '@/util/array-util';
import { dateFilterTextToRange } from '@/util/date-util';
import { DateOptions } from '@/shared/constants/ds-constants';

import 'vue2-datepicker/index.css';

export default defineComponent({
  name: 'DatePickerComponent',
  components: {
    DatePicker,
  },
  emits: ['updateDate'],
  props: {
    isDataLoading: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  setup(props, { emit }) {
    const dateLabel = ref<null | HTMLElement>(null);
    const inputDatePicker = ref<null | HTMLElement>(null);
    const datepickerPopup = ref<null | HTMLElement>(null);

    const dateTexts = ref<string>('');
    const lastDateText = ref();
    const isShowDatePicker = ref();
    const filterPayload = ref({
      datePicker: [null, null],
    });
    const datePicker = ref<[string, string] | [null]>([null, null]);

    const openDatePicker = () => {
      isShowDatePicker.value = true;
    };

    const closeDatePicker = () => {
      if (!isShowDatePicker.value) {
        return;
      }

      isShowDatePicker.value = false;
      dateTexts.value = lastDateText.value;
    };

    const updateDate = (dateText, datePicker) => {
      if (dateText && dateText.length > 0) {
        lastDateText.value = dateText;
        dateTexts.value = dateText;
      } else {
        dateTexts.value = '';
      }

      if (datePicker) {
        emit('updateDate', datePicker, null);
        return;
      }

      if (!dateText || dateText.includes('SELECT')) {
        openDatePicker();
        return;
      }

      const datePickerSelected = dateFilterTextToRange(dateText);

      if (datePickerSelected) {
        filterPayload.value = {
          ...filterPayload.value,
          datePicker: datePickerSelected,
        };

        emit('updateDate', datePickerSelected, dateText);
        return;
      }

      // !datePickerSelected
      filterPayload.value = {
        ...filterPayload.value,
        datePicker: [null, null],
      };

      emit('updateDate', [null, null], dateText);
    };

    const handleClickOutside = (e: any) => {
      const datePickerPopup = datepickerPopup.value;

      if (!datePickerPopup) {
        return;
      }

      if (e.target.className === 'go-list-link active') {
        return;
      }

      if (datepickerPopup && !datepickerPopup.value.contains(e.target as Node)) {
        closeDatePicker();
      }
    };

    const getFutureTime = (date: Date): boolean => {
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      return date > today;
    };

    const vm = getCurrentInstance().proxy;

    const filterDatePickerLabel = () => {
      let result = DateOptions.DEFAULT;

      if (dateTexts.value && dateTexts.value.length > 0) {
        enumToArray(DateOptions).forEach(dateOption => {
          if (dateTexts.value.equalsIgnoreCase(dateTexts.value, dateOption.key)) {
            result = dateOption.value;
          }
        });

        if (result === DateOptions.SELECT) {
          return filterPayload.value.datePicker?.[0] && filterPayload.value.datePicker?.[1]
            ? filterPayload.value.datePicker?.[0] + ' ~ ' + filterPayload.value.datePicker?.[1]
            : vm.$t('homeBeta.cardPart.top.filterPart.calendarTitle');
        }
      }

      return vm.$t(result);
    };

    const onChangeDate = (date: any) => {
      isShowDatePicker.value = false;

      filterPayload.value = {
        ...filterPayload.value,
        datePicker: date,
      };

      emit('updateDate', date, `${date[0]} ~ ${date[1]}`);
    };

    return {
      enumToArray,
      DateOptions,

      dateLabel,
      inputDatePicker,
      datepickerPopup,
      dateTexts,
      isShowDatePicker,
      datePicker,
      closeDatePicker,
      updateDate,
      handleClickOutside,
      getFutureTime,
      filterDatePickerLabel,
      onChangeDate,
    };
  },
});
